import { PortableTextBlocks } from '@portfolio/models'
import { toPlainText } from '@portabletext/react'

type FaqSchemaSourceItem = {
  question?: string | null
  answer?: PortableTextBlocks | PortableTextBlocks[] | null
}

type FaqSchemaMainEntityItem = {
  questionName: string
  acceptedAnswerText: string
}

export function buildFaqSchemaMainEntity(
  faqItems: ReadonlyArray<FaqSchemaSourceItem> = [],
): FaqSchemaMainEntityItem[] {
  return faqItems
    .map((faq): FaqSchemaMainEntityItem | null => {
      const questionName = faq.question?.trim() || ''
      const answerBlocks = Array.isArray(faq.answer)
        ? faq.answer
        : faq.answer
        ? [faq.answer]
        : []
      const answerText = toPlainText(answerBlocks).replace(/\s+/g, ' ').trim()

      if (!questionName || !answerText) return null

      return {
        questionName,
        acceptedAnswerText: answerText,
      }
    })
    .filter((faq): faq is FaqSchemaMainEntityItem => faq !== null)
}
